import type {VFC} from 'react';

import NoGroupsImg from 'images/no_groups.png';
import NoGroupsImgX2 from 'images/no_groups@2.png';

export const NoGroupsIcon: VFC = () => {
    return <img width={165} height={90} src={NoGroupsImg} srcSet={`${NoGroupsImgX2} 2x`} alt='' />;
};
